module.exports = __webpack_public_path__ + "static/LOGO 2-d578f6031d41cc2868ad7ccb20c31ab6.png";